import { CardSectionLabel } from '../../../../CardSectionLabel';

/** "TIN:" and the entity's TIN; nothing when it has none. */
export const BorrowerEntityTin = ({ tin }: { tin: string | undefined }) => {
    if (!tin) {
        return null;
    }

    return (
        <div>
            <CardSectionLabel>TIN:</CardSectionLabel>
            <div>{tin}</div>
        </div>
    );
};
